import styles from './HomeBody.module.css';

import { useState, useEffect, useRef, useContext } from 'react';
import Select, { components } from 'react-select';
import { formatDate } from '../../Funcoes/FormatData';
import { AuthContext } from '../../Auth/AuthProvider';

import SortableTable from '../Utils/SortableTable';
import { VerifyPermission } from '../../Funcoes/VerifyPermission';

const HomeBody = ({ dados, funcoes, encarregados, obras, contratos, onFilter, loading, modulo }) => {

    const { user } = useContext(AuthContext);

    const navigate = (matricula) => {

        if (modulo === 'rh') {

            window.open(`/modulo/${modulo}/colaborador/${matricula}`, "_blank");

        } else if (modulo === 'ssma') {

            if (VerifyPermission(user, { modulo: 'ssma', funcao: 'access_colab' })) {
                window.open(`/modulo/${modulo}/colaborador/${matricula}`, "_blank");
            }

        } else if (modulo === 'qualidade') {

            if (VerifyPermission(user, { modulo: 'qualidade', funcao: 'access_colab' })) {
                window.open(`/modulo/${modulo}/colaborador/${matricula}`, "_blank");
            }
        }
    }

    const tabelaRef = useRef(null);

    const total = dados.length;
    const ativos = dados.filter(obj => obj.STATUS === "ATIVO").length;
    const desligados = dados.filter(obj => obj.STATUS === "DESLIGADO").length;
    const afastados = dados.filter(obj => obj.STATUS === "AFASTADO").length;
    const ferias = dados.filter(obj => obj.STATUS === "FERIAS").length;
    const diretos = dados.filter(obj => obj.MAOOBRA === "D").length;
    const indiretos = dados.filter(obj => obj.MAOOBRA === "I").length;

    const [linhas, setLinhas] = useState(100)

    const [nomeColab, setNomeColab] = useState('')
    const [matColab, setMatColab] = useState('')

    const [selectedFunc, setSelectedFunc] = useState([])
    const [selectedEnc, setSelectedEnc] = useState([])
    const [selectedObra, setSelectedObra] = useState([])
    const [selectedContrato, setSelectedContrato] = useState([])
    const [selectedStatus, setSelectedStatus] = useState([])
    const [selectedMaoobra, setSelectedMaoobra] = useState([])

    const handleChange = (selected, name) => {

        switch (name) {

            case 'funcao':
                setSelectedFunc(selected);
                break;
            case 'encarregado':
                setSelectedEnc(selected);
                break;
            case 'obra':
                setSelectedObra(selected);
                break;
            case 'contrato':
                setSelectedContrato(selected);
                break;
            case 'status':
                setSelectedStatus(selected);
                break;
            case 'maoobra':
                setSelectedMaoobra(selected);
                break;
            default:
                console.error("Invalid name");

        }

    }

    useEffect(() => {

        onFilter(nomeColab, matColab, selectedFunc, selectedEnc, selectedObra, selectedContrato, selectedStatus, selectedMaoobra)

    }, [nomeColab, matColab, selectedFunc, selectedEnc, selectedObra, selectedContrato, selectedStatus, selectedMaoobra])

    useEffect(() => {

        const element = tabelaRef.current;

        if (!element) return;

        const handleScroll = () => {

            const { scrollTop, scrollHeight, clientHeight } = element;

            if (scrollTop + clientHeight >= scrollHeight - 10) {
                setLinhas((prev) => prev + 100);
            }

        };

        element.addEventListener("scroll", handleScroll);

        return () => {
            element.removeEventListener("scroll", handleScroll);
        };

    }, []);

    /** Acima do thead sticky do SortableTable (z-index: 2), para o menu não ficar atrás do cabeçalho */
    const selectStyles = {
        menu: (base) => ({ ...base, zIndex: 20 }),
    };

    const ValueContainer = ({ children, ...props }) => {
        let [values, input] = children;
        if (Array.isArray(values)) {
            const plural = values.length === 1 ? "" : "S";
            values = `${values.length} SELECIONADO${plural}`;
        }
        return (
            <components.ValueContainer {...props}>
                {values}
                {input}
            </components.ValueContainer>
        );
    };

    const viewColaboradores = () => {

        if (modulo === 'rh') {

            return true;

        } else {

            return VerifyPermission(user, { modulo: 'ssma', funcao: 'view_colab' });

        }

    }

    const columns = [
        {
            id: "pendencia",
            header: "",
            accessor: () => null,
            sortable: false,
            width: "36px",
            align: "center",
            render: (_value, row) => (
                <div className={row.DADOS === "PENDENTE" ? styles.colabPend : styles.colabOk} />
            ),
        },
        { id: "nome", header: "COLABORADOR", accessor: (r) => r.NOME },
        { id: "matricula", header: "MATRICULA", accessor: (r) => r.MATRICULA },
        { id: "funcao", header: "FUNÇÃO", accessor: (r) => r.FUNCAO },
        { id: "encarregado", header: "ENCARREGADO", accessor: (r) => r.IMEDIATO ?? "-" },
        { id: "admissao", header: "ADMISSÃO", accessor: (r) => r.ADMISSAO, sortValue: (r) => r.ADMISSAO, render: (v) => formatDate(v) },
        {
            id: "demissao",
            header: "DEMISSÃO",
            accessor: (r) => (r.DEMISSAO !== "        " ? r.DEMISSAO : null),
            sortValue: (r) => (r.DEMISSAO !== "        " ? r.DEMISSAO : null),
            render: (v) => (v ? formatDate(v) : "-"),
        },
        { id: "dias", header: "DIAS TRAB.", accessor: (r) => r.DIAS_TRAB, align: "left" },
        { id: "cc", header: "CENTRO CUSTO", accessor: (r) => r.CENTRO_CUSTO },
        { id: "contrato", header: "CONTRATO", accessor: (r) => r.CONTRATO ?? "-" },
        { id: "mo", header: "MO", accessor: (r) => r.MAOOBRA, width: "56px" },
        { id: "status", header: "STATUS", accessor: (r) => r.STATUS },
    ];

    return (
        <div className={styles.homeBody} >
            {
                viewColaboradores() && (
                    <>
                        <div className={styles.homeHeader} >

                            <div className={styles.filtersCont} >

                                <div className={styles.containerFilter} >
                                    <input
                                        type='text'
                                        placeholder='COLABORADOR...'
                                        value={nomeColab}
                                        onChange={(e) => { setNomeColab(e.target.value) }}
                                    />
                                </div>
                                <div className={styles.containerFilter} >
                                    <input
                                        type='text'
                                        placeholder='MATRICULA...'
                                        value={matColab}
                                        onChange={(e) => { setMatColab(e.target.value) }}
                                    />
                                </div>
                                <div className={styles.containerFilter} >
                                    <Select
                                        className={styles.customSelect}
                                        styles={selectStyles}
                                        placeholder='FUNÇÃO...'
                                        components={{ ValueContainer }}
                                        options={funcoes.map(funcao => ({ value: funcao, label: funcao }))}
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                        value={selectedFunc}
                                        onChange={(selected) => { handleChange(selected, 'funcao') }}
                                    />
                                </div>
                                <div className={styles.containerFilter} >
                                    <Select
                                        className={styles.customSelect}
                                        styles={selectStyles}
                                        placeholder='ENCARREGADO...'
                                        components={{ ValueContainer }}
                                        options={encarregados.map(enc => ({ value: enc, label: enc }))}
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                        value={selectedEnc}
                                        onChange={(selected) => { handleChange(selected, 'encarregado') }}
                                    />
                                </div>

                                <div className={styles.containerFilter} >
                                    <Select
                                        className={styles.customSelect}
                                        styles={selectStyles}
                                        placeholder='CENTRO CUSTO...'
                                        components={{ ValueContainer }}
                                        options={obras.map(obra => ({ value: obra, label: obra }))}
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                        value={selectedObra}
                                        onChange={(selected) => { handleChange(selected, 'obra') }}
                                    />
                                </div>
                                <div className={styles.containerFilter} >
                                    <Select
                                        className={styles.customSelect}
                                        styles={selectStyles}
                                        placeholder='CONTRATO...'
                                        components={{ ValueContainer }}
                                        options={contratos.map(cont => ({ value: cont, label: cont }))}
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                        value={selectedContrato}
                                        onChange={(selected) => { handleChange(selected, 'contrato') }}
                                    />
                                </div>
                                <div className={styles.containerFilter} >
                                    <Select
                                        className={styles.customSelect}
                                        styles={selectStyles}
                                        placeholder='STATUS...'
                                        components={{ ValueContainer }}
                                        options={[
                                            { value: 'ATIVO', label: 'ATIVO' },
                                            { value: 'DESLIGADO', label: 'DESLIGADO' },
                                            { value: 'AFASTADO', label: 'AFASTADO' },
                                            { value: 'FERIAS', label: 'FÉRIAS' },
                                        ]}
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                        value={selectedStatus}
                                        onChange={(selected) => { handleChange(selected, 'status') }}
                                    />
                                </div>
                                <div className={styles.containerFilter} >
                                    <Select
                                        className={styles.customSelect}
                                        styles={selectStyles}
                                        placeholder='MÃO DE OBRA...'
                                        components={{ ValueContainer }}
                                        options={[
                                            { value: 'D', label: 'DIRETA' },
                                            { value: 'I', label: 'INDIRETA' }
                                        ]}
                                        isMulti
                                        hideSelectedOptions={false}
                                        closeMenuOnSelect={false}
                                        value={selectedMaoobra}
                                        onChange={(selected) => { handleChange(selected, 'maoobra') }}
                                    />
                                </div>

                            </div>
                            <div className={styles.statsCont} >

                                <div className={styles.statsSquare} >
                                    <p>COLABORADORES: {total}</p>
                                    <p>ATIVOS: {ativos}&nbsp;&nbsp;&nbsp;DESLIGADOS: {desligados}</p>
                                    <p>AFASTADOS: {afastados}&nbsp;&nbsp;&nbsp;FÉRIAS: {ferias}</p>
                                    <p>DIRETO: {diretos}&nbsp;&nbsp;&nbsp;INDIRETO: {indiretos}</p>
                                </div>

                            </div>

                        </div>


                        <SortableTable
                            ref={tabelaRef}
                            columns={columns}
                            data={dados}
                            limit={linhas}
                            isLoading={loading}
                            loadingText="Carregando colaboradores..."
                            onRowClick={(row) => navigate(row.MATRICULA)}
                            rowCursor="pointer"
                            emptyText="NENHUM COLABORADOR ENCONTRADO"
                            initialSort={{ key: "nome", direction: "asc" }}
                        />
                    </>
                )
            }
        </div>

    )

}

export default HomeBody;